var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0024 1.14258L15.7573 5L0.000488281 5L0.000488281 7L15.8003 7L12.0005 10.832L13.1538 12.001L19.1538 6.0293L13.1538 -0.000976562L12.0024 1.14258Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.153,
    height: 12.002,
    transform: "matrix(-1 0 0 1 19.1531 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowicon);
export default __webpack_public_path__ + "static/media/right-arrow.icon.289e45f2663e2ab77611b48edd2b0bee.svg";
export { ForwardRef as ReactComponent };